<app-breadcrumb [title]="'Inquiries.Inquiries'" [active_item]="'Inquiries.Inquiries'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <form class="form theme-form needs-validation">
          <div class="card-body">
            <div class="row align-items-center justify-content-md-center g-3 mt-3">
              <label>{{'Forms.Budget' | translate}}</label>
              <div class="choosed-range text-center" *ngIf="value">
                <span>{{value}}</span>
              </div>
              <div class="col-md-2">
                <div class="range max">
                  <span>1000000</span>
                </div>
              </div>
              <div class="col-sm-6">
                <p-slider [(ngModel)]="value" [min]="1000" [max]="1000000" [ngModelOptions]="{standalone: true}" class="w-full"></p-slider>
              </div>
              <div class="col-md-2">
                <div class="range">
                  <span>10000</span>
                </div>
              </div>
            </div>
            <div class="footer-actions d-flex justify-content-center align-items-center mt-3">
              <!-- <button class="btn btn-pill btn-primary mt-3" type="button" (click)="save()">{{'Forms.Save' | translate}}</button>
              <button class="btn btn-pill btn-outline-primary mt-3 mx-3" type="button" (click)="userForm.reset()">{{'Forms.Cancel' | translate}}</button> -->
              <button class="btn btn-pill btn-primary mt-3" type="button" (click)="confirmRange = true">{{'Forms.Confirm' | translate}}</button>
            </div>
          </div>
          <div class="card-block pxb-30 row" *ngIf="confirmRange">
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-light">
                  <thead>
                      <th>{{'Forms.School' | translate}}</th>
                      <th>{{'Forms.Cost' | translate}}</th>
                      <th></th>
                  </thead>
                  <tbody>
                      <ng-container *ngIf="listSchools.length > 0">
                          <tr *ngFor="let school of listSchools;let i = index">
                              <td>{{school.name}}</td>
                              <td>{{school.cost}}</td>
                              <td>
                                  <button class="btn btn-pill btn-outline-primary">
                                      <span>{{'Forms.Accept' | translate}}</span>
                                  </button>
                              </td>
                          </tr>
                      </ng-container>
                      <tr *ngIf="listSchools.length == 0">
                          <td class="text-center" colspan="3">There Is No Data</td>
                      </tr>
                      <!-- <tr *ngIf="sponsorsOfficers.length == 0">
                          <td colspan="4">There Is No Data</td>
                      </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>